import { render, staticRenderFns } from "./menubutton.vue?vue&type=template&id=374157da&"
import script from "./menubutton.vue?vue&type=script&lang=ts&"
export * from "./menubutton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "menubutton.vue"
export default component.exports